import { useMemo, useState } from 'react';
export default function useIsPressed(forcePressed) {
  var [pressed, setPressed] = useState(false);
  var eventHandlers = useMemo(() => ({
    onMouseDown() {
      setPressed(true);
    },
    onMouseUp() {
      setPressed(false);
    },
    onMouseOut() {
      setPressed(false);
    },
    onTouchStart() {
      setPressed(true);
    },
    onTouchEnd() {
      setPressed(false);
    }
  }), []);
  return [forcePressed !== undefined ? forcePressed : pressed, eventHandlers];
}
//# sourceMappingURL=index.js.map